// import Vue from 'vue';
import colorPicker from "./components/color-picker.vue";
// import "jquery-ui-touch-punch";

if ($("#vue-callback").length) {

    new Vue({
        el: "#vue-callback",
        components: {
            colorPicker
        },
        data: {
            widgetType: "main",
            mainColor: "#31c858",
            popupType: "centered",
            saturation: 61,
            lightness: 49,
            value: 135,
        },
        computed: {
            darkenColor: function() {
                return tinycolor(this.mainColor).spin(-5).desaturate(12).darken(2).toHexString();
            },
            lightenColor: function() {
                return tinycolor(this.mainColor).setAlpha(0.22).toString();
            },
            thinColor: function() {
                return tinycolor(this.mainColor).setAlpha(0.1).toString();
            },
        },
        methods: {
            onChangeColor(color) {
                this.mainColor = color;
            }
        }
    })
}



// WEBPACK FOOTER //
// ./vue/callback.js